/* eslint-disable  @typescript-eslint/no-explicit-any */
/**
 * Capitalizes the first letter of a string
 * @param {string} str - The input string
 * @returns {string} The string with first letter capitalized
 */

export const capitalize = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 *
 * @param maskChar - Character to use for masking (default: *)
 * @param showLastDigits - Number of digits to show at the end (default: 4)
 * @returns A function that takes a value and returns the masked string
 */
export const createMask = (maskChar = '*', showLastDigits = 4, value: string | number): string => {
  const stringValue = String(value);
  const valueLength = stringValue.length;

  if (valueLength <= showLastDigits) {
    return stringValue;
  }

  const visiblePart = stringValue.slice(-showLastDigits);
  const maskedPart = Array(valueLength - showLastDigits)
    .fill(maskChar)
    .join('');

  return `${maskedPart}${visiblePart}`;
};

export function toDefaultPhoneFormat(source: string): string | null {
  //Filter only numbers from the input
  const cleaned = ('' + source).replace(/\D/g, '');

  //Check if the input is of correct
  const match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    // Two main reasons to hardcoded country code:
    // API always return phone numbers in flat format without country code
    // MVP just target US citizens
    return `+1 (${match[2]}) ${match[3]}-${match[4]}`;
  }

  return null;
}

export function camelToSnake(str: string): string {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();
}

export function convertKeysToSnakeCase<T>(obj: T): any {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToSnakeCase(item));
  }

  if (typeof obj === 'object' && obj.constructor === Object) {
    const result: any = {};

    for (const [key, value] of Object.entries(obj)) {
      const snakeKey = camelToSnake(key);
      result[snakeKey] = convertKeysToSnakeCase(value);
    }

    return result;
  }

  return obj;
}


export const convertArrayToSnakeCase = (arr: string[]): string[] => arr.map(camelToSnake);
